module.exports = __webpack_public_path__ + "media/assets/images/icons/no-preview-4e2f37c367ebcb6469c6651f2436cbef.png";